export default "__VITE_ASSET__cKYFSf1r__"